import {
    Component,
    Inject,
    OnDestroy,
    OnInit,
    ViewEncapsulation,
} from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { fuseAnimations } from "@fuse/animations";
import { FuseProgressBarService } from "@fuse/components/progress-bar/progress-bar.service";
import { FuseTranslationLoaderService } from "@fuse/services/translation-loader.service";
import { CodigoDTO } from "app/main/apps/shared/interfaces/codigo.interface";
import { TipoDTO } from "app/main/apps/shared/interfaces/tipo.interface";
import { ContratistaDTO } from "app/main/apps/shared/models/contratista.model";
import { CodigosService } from "app/main/apps/shared/services/rest/codigos.service";

import { DialogService } from "app/main/apps/shared/services/rest/dialog.service";
import { NotificacionesService } from "app/main/apps/shared/services/rest/notificaciones.service";
import { Subscription } from "rxjs";
import { finalize } from "rxjs/operators";
import { ContratistaService } from "../../../shared/services/rest/contratista.service";
import { DialogContratistaComponent } from "../contratistas/components/dialog-contratista/dialog-contratista.component";
import { DialogZonasCoberturaComponent } from "./components/dialog-zonas-cobertura/dialog-zonas-cobertura.component";
import { locale as english } from "./i18n/en";
import { locale as spanish } from "./i18n/es";
import { RegionComunaDTO } from "../../../shared/interfaces/region-comuna.interface";
import { DialogEspecialidadesComponent } from "./components/dialog-especialidades/dialog-especialidades.component";
import { CatalogoService } from "app/main/apps/shared/services/rest/catalogo.service";
import { CategoriaDTO } from "app/main/apps/shared/interfaces/categoria.interface";
import { MenuUsuarioService } from "app/main/apps/shared/services/util/menu-usuario.service";
import { PersonasService } from "app/main/apps/shared/services/rest/personas.service";
import { DocumentoDTO } from "app/main/apps/shared/interfaces/documento.interface";
import { GrupoServicioSolicitadoDTO } from "app/main/apps/shared/interfaces/grupo-servicio-solicitado.interface";
import { DialogDocumentosComponent } from "./components/certificaciones/dialog-documentos/dialog-documentos.component";
const ETIQUETAS = {
    identificacion: "Identificación",
    especialidades: "Especialidades",
    disponibilidad: "Zonas de Cobertura",
    pago: "Pago",
    certificaciones: "Documentos",
    solicitudes: "Solicitudes de especialidad",
    horarios: "Horarios",
};
@Component({
    selector: "app-detalle-contratista",
    templateUrl: "./detalle-contratista.component.html",
    styleUrls: ["./detalle-contratista.component.scss"],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
})
export class DetalleContratistaComponent implements OnInit, OnDestroy {
    esModal: boolean;
    rutContratista: number;
    etiquetas = null;
    certificaciones: any[];
    especialidades: any[];
    contratista: ContratistaDTO;
    bancos: CodigoDTO[];
    tiposCuenta: TipoDTO[];
    regiones: RegionComunaDTO[];
    categorias: CategoriaDTO[];
    documentos: DocumentoDTO[];
    tiposDocumentos: TipoDTO[];
    eliminado: boolean;
    grupoServiciosSolicitados: GrupoServicioSolicitadoDTO[];
    private subscripciones: Subscription;
    constructor(
        public dialogRef: MatDialogRef<DetalleContratistaComponent>,
        private _fuseTranslationLoaderService: FuseTranslationLoaderService,
        private _contratistaSrvc: ContratistaService,
        private _dialogSrvc: DialogService,
        private _notificacionSrvc: NotificacionesService,
        private _fuseProgressBarService: FuseProgressBarService,
        private _activateRoute: ActivatedRoute,
        private _codigosSrvc: CodigosService,
        private _catalogoSrvc: CatalogoService,
        public _menuUsuarioSrvc: MenuUsuarioService,
        private _personaSrvc: PersonasService,
        private router: Router,
        @Inject(MAT_DIALOG_DATA) public data: number
    ) {
        this.subscripciones = new Subscription();
        this._fuseTranslationLoaderService.loadTranslations(english, spanish);
        this.esModal = Object.keys(this.dialogRef).length > 0;
    }
    ngOnInit() {
        this.etiquetas = ETIQUETAS;

        if (this.esModal) {
            if (!Array.isArray(this.data)) {
                //console.log(this.data);
                this.rutContratista = this.data;
                this.getContratista();
            }
        } else {
            this.subscripciones.add(
                this._activateRoute.params.subscribe((params) => {
                    this.rutContratista = params["rutContratista"];
                    //console.log("this.rutContratista");
                    //console.log(this.rutContratista);
                    this.getContratista();
                })
            );
        }

        this.subscripciones.add(
            this._codigosSrvc
                .fetchBancos()
                .subscribe((resp) => (this.bancos = resp))
        );
        this.subscripciones.add(
            this._codigosSrvc
                .fetchTiposCuenta()
                .subscribe((resp) => (this.tiposCuenta = resp))
        );

        this.subscripciones.add(
            this._codigosSrvc
                .fetchRegiones()
                .subscribe((resp) => (this.regiones = resp))
        );

        this.subscripciones.add(
            this._catalogoSrvc.fetchCatalogoServicios().subscribe((resp) => {
                this.categorias = resp;
            })
        );

        if (this._menuUsuarioSrvc.esSupervisor()) {
            this.subscripciones.add(
                this._contratistaSrvc
                    .fetchGrupoServicioSolicitado(this.rutContratista)
                    .subscribe((resp) => {
                        this.grupoServiciosSolicitados = resp;
                    })
            );
        }

        this.subscripciones.add(
            this._contratistaSrvc.contratistasRefresh$.subscribe((resp) => {
                if (resp) {
                    this.getContratista();
                }
            })
        );

        this.subscripciones.add(
            this._codigosSrvc.fetchTiposDocumentos().subscribe((resp) => {
                this.tiposDocumentos = resp;
            })
        );
    }

    getContratista() {
        setTimeout(() => {
            this._fuseProgressBarService.show();
        });
        this.subscripciones.add(
            this._contratistaSrvc
                .fetchContratista(this.rutContratista)
                .pipe(finalize(() => this._fuseProgressBarService.hide()))
                .subscribe((resp) => {
                    this.contratista = resp;
                    this.eliminado = this.contratista.fechaTermino !== null;
                    this._contratistaSrvc.contratistaChanged$.next(resp);

                    this._personaSrvc
                        .fetchDocumentos(this.contratista.nrRut)
                        .subscribe((resp) => {
                            this.documentos = resp;
                            //console.log(this.documentos);
                        });
                })
        );
    }

    eliminarContratista(contratista: ContratistaDTO) {
        //const activo = contratista.fechaTermino === null;
        let mensaje =
            "Favor confirme si realmente quiere realizar la eliminación del contratista. Con esta acción no podra invitarlo a ningún próximo trabajo";
        /*if (activo) {
            mensaje =
                mensaje +
                " la eliminación del contratista. Con esta acción no podra invitarlo a ningún próximo trabajo";
        } else {
            mensaje = mensaje + " la reactivación del contratista";
        }*/
        const dialogRef = this._dialogSrvc.abrirDialogConfirm(
            "Eliminar contratista",
            mensaje
        );

        dialogRef.afterClosed().subscribe((result) => {
            //console.log(result);
            if (result) {
                //if (activo) {
                this._fuseProgressBarService.show();
                this.subscripciones.add(
                    this._contratistaSrvc
                        .eliminarContratista(contratista.nrRut)
                        .pipe(
                            finalize(() => this._fuseProgressBarService.hide())
                        )
                        .subscribe((resp) => {
                            this._notificacionSrvc.mostrarNotificacion(
                                "Contratista eliminado",
                                "success"
                            );
                            this.router.navigateByUrl("/contratistas");
                        })
                );
                setTimeout(() => {
                    this.getContratista();
                }, 1000);
                //}
                /*else {
                    this._fuseProgressBarService.show();
                    const {
                        nrRut,
                        dv,
                        nombres,
                        apellidos,
                        banco,
                        tipoCuenta,
                        numeroCuenta,
                        email,
                    } = contratista;
                    const nuevoContratista = new ContratistaDTO(
                        nrRut,
                        dv,
                        nombres,
                        apellidos,
                        banco.id,
                        tipoCuenta.id,
                        numeroCuenta,
                        email
                    );
                    this.subscripciones.add(
                        this._contratistaSrvc
                            .actualizaContratista(nuevoContratista)
                            .pipe(
                                finalize(() =>
                                    this._fuseProgressBarService.hide()
                                )
                            )
                            .subscribe((resp) => {
                                this._notificacionSrvc.mostrarNotificacion(
                                    "Contratista activado",
                                    "success"
                                );
                            })
                    );
                    setTimeout(() => {
                        this.getContratista();
                    }, 1000);*/
                //}
            } else {
                this.getContratista();
            }
        });
    }

    eliminarCertificacion(event) {
        const dialogRef = this._dialogSrvc.abrirDialogConfirm(
            "Eliminar documento",
            `Favor confirmar que realmente quiere eliminar el documento "${event.tipo.descripcion}" con vencimiento el "${event.vencimiento}"`
        );

        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                this._personaSrvc
                    .deleteDocumento(event.id, this.rutContratista)
                    .subscribe((resp) => {
                        this._notificacionSrvc.mostrarNotificacion(
                            "Documento eliminado exitosamente",
                            "success"
                        );
                        this._personaSrvc.documentosChanged$.next(true);
                    });
            }
        });
    }

    eliminaEspecialidad(event) {
        //console.log(event);

        const dialogRef = this._dialogSrvc.abrirDialogConfirm(
            "Eliminar especialidad",
            `Favor confirme si realmente quiere realizar la eliminación de la especialidad ${event.especialidad.descripcion}`
        );

        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                this.eliminarEspecialidad(event.nuevasEspecialidades);
            }
        });
    }

    eliminarEspecialidad(nuevasEspecialidades: number[]) {
        this.subscripciones.add(
            this._contratistaSrvc
                .actualizaGrupos(this.rutContratista, nuevasEspecialidades)
                .subscribe((resp) => {
                    this._notificacionSrvc.mostrarNotificacion(
                        "Especialidades actualizadas",
                        "success"
                    );
                    this.getContratista();
                })
        );
    }

    editarContratista(contratista: ContratistaDTO) {
        const dialogRef = this._dialogSrvc.abrirDialog(
            DialogContratistaComponent,
            "clase-dialog",
            "500px",
            {
                contratista,
                editar: true,
                bancos: this.bancos,
                tiposCuenta: this.tiposCuenta,
            }
        );

        dialogRef.afterClosed().subscribe((result) => {
            //console.log(result);
            if (result) {
                this._fuseProgressBarService.show();
                const {
                    nombres,
                    apellidos,
                    banco,
                    tipoCuenta,
                    nroCuenta,
                    correo,
                } = result;

                const contratistaEdit = new ContratistaDTO(
                    contratista.nrRut,
                    contratista.dv,
                    nombres,
                    apellidos,
                    banco,
                    tipoCuenta,
                    nroCuenta,
                    correo
                );
                this.subscripciones.add(
                    this._contratistaSrvc
                        .actualizaContratista(contratistaEdit)
                        .pipe(
                            finalize(() => this._fuseProgressBarService.hide())
                        )
                        .subscribe((resp) => {
                            this._notificacionSrvc.mostrarNotificacion(
                                "Contratista actualizado correctamente",
                                "success"
                            );
                            this.getContratista();
                        })
                );
            }
        });
    }

    eliminaComuna(event) {
        //console.log(event);

        const dialogRef = this._dialogSrvc.abrirDialogConfirm(
            "Eliminar zona de cobertura",
            `Favor confirme si realmente quiere realizar la eliminación de la zona de cobertura ${event.comuna.nombre}`
        );

        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                this.eliminarComuna(event.nuevasComunas);
            }
        });
    }

    eliminarComuna(nuevasComunas: number[]) {
        this.subscripciones.add(
            this._contratistaSrvc
                .actualizaComunas(this.rutContratista, nuevasComunas)
                .subscribe((resp) => {
                    this._notificacionSrvc.mostrarNotificacion(
                        "Zonas de cobertura actualizadas",
                        "success"
                    );
                    this.getContratista();
                })
        );
    }

    agregarEspecialidades() {
        //console.log("llego");
        this._dialogSrvc.abrirDialog(
            DialogEspecialidadesComponent,
            "clase-dialog",
            "600px",
            {
                categorias: this.categorias,
                rutContratista: this.rutContratista,
                gruposContratrista: this.contratista.gruposServicio,
                gruposSolicitados: this.grupoServiciosSolicitados,
            }
        );
    }

    agregarDocumento() {
        const dialogRef = this._dialogSrvc.abrirDialog(
            DialogDocumentosComponent,
            "clase-dialog",
            "600px",
            {
                tipos: this.tiposDocumentos,
            }
        );

        dialogRef.afterClosed().subscribe((result) => {
            //console.log(result);
            if (result) {
                this._personaSrvc
                    .saveDocumento(
                        result.tipo,
                        this.rutContratista,
                        result.fecha,
                        result.documento
                    )
                    .subscribe((resp) => {
                        this._notificacionSrvc.mostrarNotificacion(
                            "Documento guadardo exitosamente",
                            "success"
                        );
                        this._personaSrvc.documentosChanged$.next(true);
                    });
            }
        });
    }

    agregarZonasCobertura() {
        //console.log("llego");
        this._dialogSrvc.abrirDialog(
            DialogZonasCoberturaComponent,
            "clase-dialog",
            "600px",
            {
                regiones: this.regiones,
                rutContratista: this.rutContratista,
                comunasContratrista: this.contratista.comunas,
            }
        );
    }

    aprobarSolicitud(datos: GrupoServicioSolicitadoDTO[]) {
        //console.log("datos desde el emiter");
        //console.log(datos);
        let ids: number[] = datos.map((o: GrupoServicioSolicitadoDTO) => o.id);
        //console.log(ids);

        const gruposExistentes = this.contratista.gruposServicio.map(
            (o) => o.id
        );
        ids = ids.concat(gruposExistentes);

        this._contratistaSrvc
            .actualizaGrupos(this.rutContratista, ids)
            .subscribe((resp) => {
                this._contratistaSrvc.contratistasRefresh$.next(true);
                this._notificacionSrvc.mostrarNotificacion(
                    "Solicitudes aprobadas",
                    "success"
                );
            });
    }

    ngOnDestroy() {
        this.subscripciones.unsubscribe();
        //console.log("destroyed");
    }
}
